// notificationSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCollectionSites,
  fetchTrapTypes,
  updateCollectionSite,
  createCollectionSite,
  createTrapType,
  updateTrapType,
} from "./actions";
import { CollectionSite, CollectionDetailsState } from "../../types";

const initialState: CollectionDetailsState = {
  collectionSites: [],
  collectionSiteCount: 0,
  collectionSitesLoading: false,
  trapTypes: [],
  trapTypeCount: 0,
  trapTypesLoading: false,
  open: false,
};

const collectionSitesSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCollectionSites.pending, (state) => {
      state.collectionSitesLoading = true;
      state.error = null;
    });
    builder.addCase(fetchCollectionSites.fulfilled, (state, action) => {
      state.collectionSitesLoading = false;
      state.collectionSites = action.payload?.data || [];
      state.collectionSiteCount = action.payload?.count || 0;
    });
    builder.addCase(fetchCollectionSites.rejected, (state, action) => {
      state.collectionSitesLoading = false;
      state.error = action.error.message || "Failed to fetch collection sites";
    });
    builder.addCase(fetchTrapTypes.pending, (state) => {
      state.trapTypesLoading = true;
      state.error = null;
    });
    builder.addCase(fetchTrapTypes.fulfilled, (state, action) => {
      state.trapTypesLoading = false;
      state.trapTypes = action.payload?.data || [];
      state.trapTypeCount = action.payload?.count || 0;
    });
    builder.addCase(fetchTrapTypes.rejected, (state, action) => {
      state.trapTypesLoading = false;
      state.error = action.error.message || "Failed to trapTypes";
    });
    builder.addCase(updateCollectionSite.fulfilled, (state, action) => {
      let collectionSite = action.payload;
      if (collectionSite) {
        state.collectionSites = state.collectionSites.map((cur) => {
          if (cur.id === collectionSite?.id) {
            return collectionSite || {};
          }
          return cur;
        });
      }
    });
    builder.addCase(createCollectionSite.fulfilled, (state, action) => {
      let collectionSite: CollectionSite = action.payload;
      state.collectionSites = [collectionSite, ...state.collectionSites];
    });
    builder.addCase(createTrapType.fulfilled, (state, action) => {
      let trapType = action.payload;
      if (trapType) {
        state.trapTypes = [trapType, ...state.trapTypes];
      }
    });
    builder.addCase(updateTrapType.fulfilled, (state, action) => {
      let trapType = action.payload;
      if (trapType) {
        state.trapTypes = state.trapTypes.map((cur) => {
          if (cur.id === trapType?.id) {
            return trapType || {};
          }
          return cur;
        });
      }
    });
  },
});

// export const { showNotification, hideNotification } = collectionsSlice.actions;
export default collectionSitesSlice.reducer;
